import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useContractEvents } from "@/hooks/useContractEvents";
import { useColorMode } from "@chakra-ui/react";
import { highlight, languages } from "prismjs";
import "prismjs/components/prism-json";
import * as React from "react";
import Editor from "react-simple-code-editor";
interface EventAbiSelectorProps {
  label: string;
  description?: string;
  headerRight?: React.ReactNode;
  value: any; // The selected event from workflow data (source of truth)
  onChange: (value: any) => void;
  chainId: any;
  contractAddress: any;
}
export default function EventAbiSelector(t0) {
  const $ = _c(55);
  const {
    label,
    description,
    headerRight,
    value,
    onChange,
    chainId,
    contractAddress
  } = t0;
  const [isManuallyEdited, setIsManuallyEdited] = React.useState(false);
  const {
    colorMode
  } = useColorMode();
  const hasChainId = chainId && chainId !== "";
  const hasContractAddress = contractAddress && contractAddress !== "";
  const shouldShow = hasChainId;
  const t1 = !isManuallyEdited && shouldShow && hasContractAddress;
  let t2;
  if ($[0] !== chainId || $[1] !== contractAddress || $[2] !== t1 || $[3] !== value) {
    t2 = {
      chainId,
      address: contractAddress,
      enabled: t1,
      selectedEventJson: value
    };
    $[0] = chainId;
    $[1] = contractAddress;
    $[2] = t1;
    $[3] = value;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    events,
    isLoading,
    selectedEvent,
    selectedEventName,
    selectEvent
  } = useContractEvents(t2);
  let t3;
  if ($[5] !== events || $[6] !== selectedEvent || $[7] !== selectedEventName) {
    t3 = selectedEvent && events.length > 0 ? events.findIndex(e => e.name === selectedEventName) : -1;
    $[5] = events;
    $[6] = selectedEvent;
    $[7] = selectedEventName;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const selectedIndex = t3;
  let t4;
  if ($[9] !== value) {
    t4 = typeof value === "string" ? value : value ? JSON.stringify(value, null, 2) : "";
    $[9] = value;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const editorValue = t4;
  let t5;
  if ($[11] !== onChange) {
    t5 = newValue => {
      onChange(newValue);
      setIsManuallyEdited(true);
    };
    $[11] = onChange;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const handleChange = t5;
  let t6;
  if ($[13] !== onChange || $[14] !== selectEvent) {
    t6 = event => {
      onChange(selectEvent(event));
    };
    $[13] = onChange;
    $[14] = selectEvent;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  const handleSelectEvent = t6;
  if (!shouldShow) {
    return null;
  }
  let t7;
  if ($[16] !== headerRight || $[17] !== isManuallyEdited || $[18] !== label) {
    t7 = label && <div className="flex items-center justify-between"><label className="field-label block">{label}</label><div className="flex items-center gap-3"><div className="border-ds-border-default bg-ds-surface-card inline-flex rounded-lg border p-0.5"><button type="button" onClick={() => setIsManuallyEdited(false)} className={`rounded-md px-3 py-1 text-xs font-medium transition-colors ${!isManuallyEdited ? "bg-green-500/15 text-green-700 dark:text-green-400" : "text-ds-text-subtle hover:text-ds-text-primary dark:text-ds-text-disabled dark:hover:text-zinc-100"}`}>Auto</button><button type="button" onClick={() => setIsManuallyEdited(true)} className={`rounded-md px-3 py-1 text-xs font-medium transition-colors ${isManuallyEdited ? "bg-ds-neutral-200 text-ds-text-primary dark:bg-ds-neutral-700 dark:text-zinc-100" : "text-ds-text-subtle hover:text-ds-text-primary dark:text-ds-text-disabled dark:hover:text-zinc-100"}`}>Manual</button></div>{headerRight}</div></div>;
    $[16] = headerRight;
    $[17] = isManuallyEdited;
    $[18] = label;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== description || $[21] !== isManuallyEdited) {
    t8 = description && isManuallyEdited && <p className="text-ds-text-subtle dark:text-ds-text-disabled text-xs">{description}</p>;
    $[20] = description;
    $[21] = isManuallyEdited;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  let t9;
  if ($[23] !== isLoading || $[24] !== isManuallyEdited) {
    t9 = isLoading && !isManuallyEdited && <p className="text-xs text-blue-600 dark:text-blue-400">Fetching available events...</p>;
    $[23] = isLoading;
    $[24] = isManuallyEdited;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  let t10;
  if ($[26] !== events || $[27] !== handleSelectEvent || $[28] !== isManuallyEdited || $[29] !== selectedIndex) {
    t10 = !isManuallyEdited && events.length > 0 && <div className="space-y-3"><div className="flex items-center justify-between"><p className={`text-sm font-medium ${selectedIndex !== -1 ? "text-green-600 dark:text-green-400" : "text-ds-text-subtle"}`}>{events.length} Event{events.length !== 1 ? "s" : ""} Available{selectedIndex === -1 ? " \u2014 Select One:" : ""}</p></div><Accordion type="single" collapsible={true} className="space-y-2" role="radiogroup" onValueChange={val => {
        if (!val) {
          return;
        }
        const idx = Number(val.replace("event-", ""));
        if (!isNaN(idx) && idx !== selectedIndex) {
          handleSelectEvent(events[idx]);
        }
      }}>{events.map((event_0, index) => {
          const isSelected = index === selectedIndex;
          return <AccordionItem key={index} value={`event-${index}`} className={`rounded-lg border ${isSelected ? "border-green-500/50 bg-green-500/10" : "border-ds-border-default bg-ds-surface-secondary"}`}><AccordionTrigger className="overflow-hidden px-4 hover:no-underline"><div className="flex w-full min-w-0 cursor-pointer items-center gap-3" onClick={e_0 => {
                e_0.stopPropagation();
                if (!isSelected) {
                  handleSelectEvent(event_0);
                }
              }}><div role="radio" aria-checked={isSelected} aria-label={`${event_0.name} event`} className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2 transition-colors ${isSelected ? "border-green-500" : "border-zinc-500 dark:border-zinc-400"}`}>{isSelected && <div className="h-2.5 w-2.5 rounded-full bg-green-500" />}</div><div className="min-w-0 flex-1 text-left"><p className="text-ds-text-primary truncate font-mono text-sm font-semibold">{event_0.name}</p><p className="text-ds-text-subtle text-xs">{event_0.inputs?.length || 0} parameter{(event_0.inputs?.length || 0) !== 1 ? "s" : ""}</p></div></div></AccordionTrigger><AccordionContent className="px-4">{event_0.inputs && event_0.inputs.length > 0 && <div className="space-y-2 pt-2"><p className="text-ds-text-secondary text-xs font-medium">Parameters:</p><div className="space-y-1">{event_0.inputs.map(_temp)}</div><details className="mt-2 text-xs"><summary className="text-ds-text-subtle hover:text-ds-text-primary cursor-pointer">View raw JSON</summary><pre className="text-2xs bg-ds-surface-tertiary text-ds-text-primary mt-2 overflow-x-auto rounded p-2 font-mono">{JSON.stringify(event_0, null, 2)}</pre></details></div>}</AccordionContent></AccordionItem>;
        })}</Accordion></div>;
    $[26] = events;
    $[27] = handleSelectEvent;
    $[28] = isManuallyEdited;
    $[29] = selectedIndex;
    $[30] = t10;
  } else {
    t10 = $[30];
  }
  let t11;
  if ($[31] !== events || $[32] !== isLoading || $[33] !== isManuallyEdited || $[34] !== selectedEvent) {
    t11 = !isManuallyEdited && !isLoading && events.length === 0 && selectedEvent && <div className="space-y-3"><div><h4 className="text-ds-text-primary font-mono text-sm font-semibold">{selectedEvent.name}</h4><p className="text-ds-text-subtle mt-1 text-xs">{selectedEvent.inputs?.length || 0} parameter{(selectedEvent.inputs?.length || 0) !== 1 ? "s" : ""}</p></div>{selectedEvent.inputs && selectedEvent.inputs.length > 0 && <div className="space-y-2"><p className="text-ds-text-secondary text-xs font-medium">Parameters:</p><div className="space-y-1">{selectedEvent.inputs.map(_temp2)}</div></div>}<details className="text-xs"><summary className="text-ds-text-subtle hover:text-ds-text-primary cursor-pointer">View raw JSON</summary><pre className="text-2xs bg-ds-surface-tertiary text-ds-text-primary mt-2 overflow-x-auto rounded p-2 font-mono">{JSON.stringify(selectedEvent, null, 2)}</pre></details></div>;
    $[31] = events;
    $[32] = isLoading;
    $[33] = isManuallyEdited;
    $[34] = selectedEvent;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== events || $[37] !== hasContractAddress || $[38] !== isLoading || $[39] !== isManuallyEdited || $[40] !== selectedEvent) {
    t12 = !isManuallyEdited && !isLoading && events.length === 0 && !selectedEvent && <div className="border-ds-border-default bg-ds-surface-secondary rounded-lg border p-4 text-center"><p className="text-ds-text-subtle text-sm">{hasContractAddress ? "No events found for this contract." : "Enter a contract address to auto-detect events."}</p><button type="button" onClick={() => setIsManuallyEdited(true)} className="mt-2 text-sm font-medium text-green-600 hover:text-green-700 dark:text-green-400 dark:hover:text-green-300">Paste ABI manually</button></div>;
    $[36] = events;
    $[37] = hasContractAddress;
    $[38] = isLoading;
    $[39] = isManuallyEdited;
    $[40] = selectedEvent;
    $[41] = t12;
  } else {
    t12 = $[41];
  }
  let t13;
  if ($[42] !== colorMode || $[43] !== editorValue || $[44] !== handleChange || $[45] !== isManuallyEdited) {
    t13 = isManuallyEdited && <><div className="border-ds-neutral-300 dark:border-ds-neutral-700 bg-ds-surface-card rounded-lg border focus-within:border-green-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-green-500/20"><Editor value={editorValue} onValueChange={handleChange} highlight={_temp3} placeholder="{}" padding={12} style={{
          fontFamily: "\"Fira Code\", \"Fira Mono\", Consolas, Monaco, \"Courier New\", monospace",
          fontSize: 14,
          lineHeight: 1.6,
          minHeight: "250px",
          outline: "none"
        }} preClassName="text-ds-text-primary dark:text-zinc-200" textareaClassName="caret-zinc-900 dark:caret-white" className={colorMode === "dark" ? "prism-dark-theme" : "prism-light-theme"} /></div><style jsx={true} global={true}>{`
            /* Light theme colors - unified with WorkflowJsonView */
            .prism-light-theme {
              color: #18181b;
            }
            .prism-light-theme .token.comment,
            .prism-light-theme .token.prolog,
            .prism-light-theme .token.doctype,
            .prism-light-theme .token.cdata {
              color: #a1a1aa;
            }
            .prism-light-theme .token.punctuation {
              color: #71717a;
            }
            .prism-light-theme .token.property,
            .prism-light-theme .token.tag,
            .prism-light-theme .token.symbol {
              color: #a855f7;
            }
            .prism-light-theme .token.boolean,
            .prism-light-theme .token.number,
            .prism-light-theme .token.constant {
              color: #ea580c;
            }
            .prism-light-theme .token.deleted {
              color: #dc2626;
            }
            .prism-light-theme .token.selector,
            .prism-light-theme .token.string,
            .prism-light-theme .token.char,
            .prism-light-theme .token.builtin,
            .prism-light-theme .token.inserted {
              color: #059669;
            }
            .prism-light-theme .token.attr-name,
            .prism-light-theme .token.function,
            .prism-light-theme .token.class-name {
              color: #d97706;
            }
            .prism-light-theme .token.operator,
            .prism-light-theme .token.entity,
            .prism-light-theme .token.url,
            .prism-light-theme .token.atrule,
            .prism-light-theme .token.keyword {
              color: #2563eb;
            }
            .prism-light-theme .token.attr-value {
              color: #059669;
            }

            /* Dark theme colors - unified with WorkflowJsonView */
            .prism-dark-theme {
              color: #e4e4e7;
            }
            .prism-dark-theme .token.comment,
            .prism-dark-theme .token.prolog,
            .prism-dark-theme .token.doctype,
            .prism-dark-theme .token.cdata {
              color: #71717a;
            }
            .prism-dark-theme .token.punctuation {
              color: #a1a1aa;
            }
            .prism-dark-theme .token.property,
            .prism-dark-theme .token.tag,
            .prism-dark-theme .token.symbol {
              color: #e879f9;
            }
            .prism-dark-theme .token.boolean,
            .prism-dark-theme .token.number,
            .prism-dark-theme .token.constant {
              color: #fb923c;
            }
            .prism-dark-theme .token.deleted {
              color: #ef4444;
            }
            .prism-dark-theme .token.selector,
            .prism-dark-theme .token.string,
            .prism-dark-theme .token.char,
            .prism-dark-theme .token.builtin,
            .prism-dark-theme .token.inserted {
              color: #34d399;
            }
            .prism-dark-theme .token.attr-name,
            .prism-dark-theme .token.function,
            .prism-dark-theme .token.class-name {
              color: #fbbf24;
            }
            .prism-dark-theme .token.operator,
            .prism-dark-theme .token.entity,
            .prism-dark-theme .token.url,
            .prism-dark-theme .token.atrule,
            .prism-dark-theme .token.keyword {
              color: #60a5fa;
            }
            .prism-dark-theme .token.attr-value {
              color: #34d399;
            }
          `}</style></>;
    $[42] = colorMode;
    $[43] = editorValue;
    $[44] = handleChange;
    $[45] = isManuallyEdited;
    $[46] = t13;
  } else {
    t13 = $[46];
  }
  let t14;
  if ($[47] !== t10 || $[48] !== t11 || $[49] !== t12 || $[50] !== t13 || $[51] !== t7 || $[52] !== t8 || $[53] !== t9) {
    t14 = <div className="space-y-2">{t7}{t8}{t9}{t10}{t11}{t12}{t13}</div>;
    $[47] = t10;
    $[48] = t11;
    $[49] = t12;
    $[50] = t13;
    $[51] = t7;
    $[52] = t8;
    $[53] = t9;
    $[54] = t14;
  } else {
    t14 = $[54];
  }
  return t14;
}
function _temp3(code) {
  return highlight(code, languages.json, "json");
}
function _temp2(input_0, idx_1) {
  return <div key={idx_1} className="bg-ds-surface-tertiary flex items-center gap-2 rounded px-2 py-1 text-xs"><span className="text-ds-text-primary font-mono font-medium">{input_0.name}</span><span className="text-ds-text-subtle">{input_0.type}</span>{input_0.indexed && <span className="text-3xs rounded bg-green-500/20 px-1.5 py-0.5 font-medium text-green-600 dark:text-green-400">indexed</span>}</div>;
}
function _temp(input, idx_0) {
  return <div key={idx_0} className="bg-ds-surface-tertiary flex items-center gap-2 rounded px-2 py-1 text-xs"><span className="text-ds-text-primary font-mono font-medium">{input.name}</span><span className="text-ds-text-subtle">{input.type}</span>{input.indexed && <span className="text-3xs rounded bg-green-500/20 px-1.5 py-0.5 font-medium text-green-600 dark:text-green-400">indexed</span>}</div>;
}